import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import Utility from '../../util/utilityfunctions';
import {cloneDeep} from 'lodash';

export default function customFiltersReducer(state = initialstate.customFilters, action) {
    switch (action.type) {
        case types.SET_CUSTOM_FILTER: {
            const { filterKey, filterItemName, value: actionValue } = action;
            const currentFilterState = state[filterKey] || {};
            let filters = cloneDeep(currentFilterState);

			let value = actionValue;
			if (!Utility.hasValue(value)) {
				// If filter is being disabled, set to empty array so it's removed from the URL.
				value = [];
			}

            if (filterItemName) {
                if (value.length < 1) {
                    const { [filterItemName]: removedProperty, ...stateRest } = filters;
                    return {
                        ...state,
                        [filterKey]: stateRest
                    };
                }
                filters[filterItemName] = value;

                return {
                    ...state,
                    [filterKey]: filters
                };
            }

            return state;
        }
        case types.CLEAR_CUSTOM_FILTERS: {
            const { filterKey } = action;
            const currentFilterState = state[filterKey] || {};
            // All filters that are part of additional components should be added here if don't want to be clear on filter clear.
            return {
                ...state,
                [filterKey]: {
                    searchTerm: currentFilterState.searchTerm,
                    performSearch: currentFilterState.performSearch,
                    selectedStEntityId: currentFilterState.selectedStEntityId,
                    isInitialized: true
                }
            };
        }
        case types.SET_CUSTOM_FILTER_SEARCH: {
            const { filterKey, value } = action;
            const currentFilterState = state[filterKey] || {};
            return {
                ...state,
                [filterKey]: {
                    ...currentFilterState,
                    searchTerm: value
                }
            };
        }
        case types.FORCE_CUSTOM_FILTER_SEARCH: {
            const { filterKey } = action;
            const currentFilterState = state[filterKey] || {};
            return {
                ...state,
                [filterKey]: {
                    ...currentFilterState,
                    performSearch: (currentFilterState.performSearch || 0) + 1
                }
            };
        }
        case types.INITIALIZE_CUSTOM_FILTERS: {
            const { filterKey, filters, additionalComponentsFilters } = action;
            return {
                ...state,
                [filterKey]: {
                    performSearch: 0,
                    isInitialized: true,
                    ...filters,
                    ...additionalComponentsFilters
                }
            };
        }
        case types.SET_SELECTED_ST_ENTITY: {
            const { filterKey, value } = action;
            const currentFilterState = state[filterKey] || {};
            return {
                ...state,
                [filterKey]: {
                    ...currentFilterState,
                    selectedStEntityId: value
                }
            };
        }
        default:
            return state;
    }
};